import React from "react";
import "./index.scss";

const classPrefix = "yfm-product-detail-top-bar-skeleton";

const TopBarSkeleton: React.FC = () => {
  return (
    <div className={`${classPrefix}`}>
      <div className={`${classPrefix}__container yfm-app-page-width-fix`}>
        <span className="yfm-is-skeleton">
          Earn above public commissions by downloading
        </span>
        <br />
        <span className="yfm-is-skeleton">YooFinds! Download Now &gt;&gt;</span>
      </div>
    </div>
  );
};

export default TopBarSkeleton;
